import type { LanguageBreakdown as LanguageBreakdownDto } from '@ederest/contracts';
import './language-breakdown.css';
import { LowSampleBadge } from '../../shared/ui/LowSampleBadge.js';

const LANGUAGE_LABELS: Record<string, string> = {
  fr: 'Français',
  ar: 'Arabe',
  zgh: 'Amazighe',
  unknown: 'Non renseignée',
};

/**
 * The same indicators side by side per display language (functional §13.2
 * "Restitution par langue"): a defect specific to one version shows here.
 */
export function LanguageBreakdown({ languages }: { languages: readonly LanguageBreakdownDto[] }) {
  if (languages.length === 0) return <p className="chart-empty">Aucune langue mesurée.</p>;

  return (
    <div className="languages">
      {languages.map((entry) => (
        <article key={entry.language} className="languages__card" data-language={entry.language}>
          <header className="languages__head">
            <span className="languages__name">{LANGUAGE_LABELS[entry.language] ?? entry.language}</span>
            <span className="languages__code">{entry.language}</span>
            {entry.lowConfidence && <LowSampleBadge />}
          </header>
          <dl className="languages__facts">
            <div>
              <dt>Sessions</dt>
              <dd>{entry.sessions.toLocaleString('fr-FR')}</dd>
            </div>
            <div>
              <dt>Achèvement</dt>
              <dd>{(entry.completionRate * 100).toFixed(1)} %</dd>
            </div>
            <div>
              <dt>Hésitations</dt>
              <dd>{entry.hesitationCount.toLocaleString('fr-FR')}</dd>
            </div>
            <div>
              <dt>Erreurs</dt>
              <dd>{entry.errorCount.toLocaleString('fr-FR')}</dd>
            </div>
          </dl>
        </article>
      ))}
    </div>
  );
}
